<template>
  <!--
    Code By     : 陈伦刚
    CreateTime  : 2020-12-14 01:36:00
    Description : 音频上传
  -->
  <gaia-upload
    ref="upload"
    v-model="form"
    types="other"
    :formatList="formatList"
  >
    <div v-show="settingVisible && modalVisible">
      <div class="title" style="font-size: 14px">基本信息</div>
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        status-icon
        label-position="top"
        size="mini"
      >
        <el-checkbox
          v-model="sameTitle"
          style="float: right"
          @change="changeTitle"
        >
          <span>统一标题</span>
          <question-prompt
            content="勾选此项并“应用到全部”时，所有视频使用同一标题，标题名称按添加顺序增加数字编号。"
          />
        </el-checkbox>
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="基础信息" prop="info">
          <div class="input-group">
            <el-input v-model="form.detail" placeholder="素材内容"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="下载设置" prop="allowDownload">
          <el-select
            v-model="form.allowDownload"
            placeholder="请选择"
            style="width: 48.2%"
            disabled
          >
            <el-option label="免费下载" :value="false"> </el-option>
            <el-option label="付费下载" :value="true"> </el-option>
          </el-select>
          <span
            v-if="form.allowDownload"
            class="price-setting-button"
            @click="showPriceSetting"
          >
            设置价格
          </span>
        </el-form-item>
        <el-form-item
          label="捐赠设置"
          prop="acceptDonations"
          style="position: relative; top: -75px; left: 251px"
        >
          <el-select
            v-model="form.acceptDonations"
            placeholder="请选择"
            style="width: 48.2%"
          >
            <el-option label="不接受捐赠" :value="false"> </el-option>
            <el-option label="接受捐赠" :value="true"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分类标签" prop="tags" style="margin-top: -75px">
          <el-input
            v-model="form.tags"
            :readonly="true"
            @focus="tagSelectVisible = true"
          ></el-input>
          <tag-select
            v-model="tagSelectVisible"
            :tags="form.tags"
            :tagsList="tagsList"
            @change="
              (tags) => {
                form.tags = tags;
              }
            "
          />
        </el-form-item>
        <el-divider></el-divider>
        <el-form-item label="封面（900*506px）" prop="cover">
          <upload-cover :src="form.cover" @change="coverChange" />
        </el-form-item>
        <el-form-item>
          <div class="info-box">
            <div class="item">
              <div class="name">幕后故事</div>
              <div class="box" @click="openEditDetail">
                <i class="el-icon-plus"></i>
                <span>{{ !form.story ? "编辑故事" : "重新编辑" }}</span>
              </div>
            </div>
            <div class="item">
              <div class="name">
                <span>人像授权协议 </span>
                <question-prompt
                  content="当您的素材中涉及肖像权及物权内容时，请上传肖像权及物权授权协议，可以PDF、JPG或文档格式提交。"
                />
              </div>
              <div class="box">
                <div>
                  <upload-file
                    v-model="form.portraitureRightId"
                    type="po"
                    format="image/jpeg,application/pdf,application/msword"
                  >
                    <i class="el-icon-plus"></i>
                    <span>{{
                      !form.portraitureRightId ? "选择协议" : "重新选择"
                    }}</span>
                  </upload-file>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="name">
                <span>物权授权协议</span>
                <question-prompt
                  content="当您的素材中涉及肖像权及物权内容时，请上传肖像权及物权授权协议，可以PDF、JPG或文档格式提交。"
                />
              </div>
              <div class="box">
                <upload-file
                  v-model="form.realRightId"
                  type="re"
                  format="image/jpeg,application/pdf,application/msword"
                >
                  <i class="el-icon-plus"></i>
                  <span>{{ !form.realRightId ? "选择协议" : "重新选择" }}</span>
                </upload-file>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button
            :disabled="!access"
            :loading="applyLoading"
            type="primary"
            @click="upload"
            style="width: 74%"
          >
            应用
          </el-button>
          <el-button
            :disabled="!access"
            plain
            @click="submit"
            style="width: 23.9%"
            type="primary"
          >
            应用到全部
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="access"> 上传即表示您已同意网站 </el-checkbox>
          <a
            class="pact"
            href="https://gaiamount.com/desktop/richPage?type=2"
            target="_blank"
          >
            《上传协议》
          </a>
        </el-form-item>
      </el-form>
    </div>
    <div v-show="editDetailVisible">
      <div class="title" style="font-size: 14px">编写幕后故事</div>
      <gaia-editor v-model="story" />
      <div style="margin-top: 20px">
        <el-button
          type="primary"
          size="mini"
          style="width: 74%"
          @click="editDetailSave(true)"
        >
          保存
        </el-button>
        <el-button
          size="mini"
          plain
          style="width: 23.9%"
          @click="editDetailSave(false)"
        >
          取消
        </el-button>
      </div>
    </div>
    <div v-show="priceSettingVisible" class="video-price-setting">
      <div class="title" style="font-size: 14px">下载付费设置</div>
      <div class="explain">
        原价（＞0元）＞折扣价＞会员折扣价【专业用户≥高级用户≥商业用户价格。未设置折扣价时仍可设置<br />
        会员折扣价】;<br />
        折扣价/会员折扣价为“0”时代表限时免费，必须设置折扣时间（折扣价为“0”时无法设<br />
        置会员折扣价）; 折扣时间到期后自动恢复原价。<br />
      </div>
      <div style="color: #ff5b67; font-size: 14px">○ 原价</div>
      <div class="price-item">
        <el-input
          maxlength="7"
          type="number"
          placeholder="源文件"
          v-model="form.firstPrice"
          @change="priceMoreThan"
          @focus="$event.currentTarget.select()"
          size="mini"
        >
          <span slot="suffix" class="el-input__icon">元</span>
        </el-input>
        <div>
          <el-checkbox v-model="form.haveSetDisPrice">折扣价</el-checkbox>
        </div>
        <div class="price-item">
          <el-input
            maxlength="7"
            type="number"
            :disabled="!form.haveSetDisPrice"
            placeholder="源文件"
            v-model="form.discountPrice"
            @change="priceMoreThan"
            @focus="$event.currentTarget.select()"
            size="mini"
          >
            <span slot="suffix" class="el-input__icon">元</span>
          </el-input>
        </div>
        <el-checkbox v-model="form.haveSetMemDisPrice">会员折扣价</el-checkbox>
        <div class="price-item">
          <el-input
            maxlength="7"
            type="number"
            :disabled="!form.haveSetMemDisPrice"
            placeholder="源文件"
            v-model="form.disProPrice"
            @change="priceMoreThan"
            @focus="$event.currentTarget.select()"
            size="mini"
          >
            <span slot="suffix" class="el-input__icon">元</span>
          </el-input>
          <span class="tag" style="color: #ff962c">(PRO)</span>
        </div>
        <div class="price-item">
          <el-input
            maxlength="7"
            type="number"
            :disabled="!form.haveSetMemDisPrice"
            placeholder="源文件"
            v-model="form.disAdvPrice"
            @change="priceMoreThan"
            @focus="$event.currentTarget.select()"
            size="mini"
          >
            <span slot="suffix" class="el-input__icon">元</span>
          </el-input>
          <span class="tag" style="color: #fb4e54">(ADV)</span>
        </div>
        <div class="price-item">
          <el-input
            maxlength="7"
            type="number"
            :disabled="!form.haveSetMemDisPrice"
            placeholder="源文件"
            v-model="form.disBnsPrice"
            @change="priceMoreThan"
            @focus="$event.currentTarget.select()"
            size="mini"
          >
            <span slot="suffix" class="el-input__icon">元</span>
          </el-input>
          <span class="tag" style="color: #706cd1">(BNS)</span>
        </div>
        <el-checkbox v-model="form.haveSetTime">折扣时间</el-checkbox>
        <div class="price-item">
          <el-date-picker
            :disabled="!form.haveSetTime"
            v-model="form.time"
            size="mini"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
        <div style="margin-top: 60px">
          <el-button
            type="primary"
            size="mini"
            @click="priceSettingConfirm"
            style="width: 100%"
          >
            保存
          </el-button>
        </div>
      </div>
    </div>
  </gaia-upload>
</template>

<script>
import gaiaUpload from "@/components/upload/gaia-upload.vue";
import UploadCover from "@/components/upload/upload-cover";
import QuestionPrompt from "@/components/question-prompt/question-prompt";
import UploadFile from "@/components/upload/upload-file";
import GaiaEditor from "@/components/gaia-editor/gaia-editor";
import { compressedList } from "./format-list";
import { otherMaterial, checkVerified } from "@/api/upload";
import { getMaterialTags, getOwnMaterialTags } from "@/api/material";
import tagSelect from "@/components/tag-select/tag-select";
export default {
  components: {
    gaiaUpload,
    UploadCover,
    QuestionPrompt,
    UploadFile,
    GaiaEditor,
    tagSelect,
  },
  data() {
    const info = (rule, value, callback) => {
      if (this.form.detail == "") {
        callback(new Error("基础信息不能为空"));
      } else {
        callback();
      }
    };
    const tags = (rule, value, callback) => {
      if (this.form.tags.split(";").length < 2) {
        callback(new Error("分类标签至少选择两个"));
      } else {
        callback();
      }
    };
    const coverRule = (rule, value, callback) => {
      if (this.form.cover == "") {
        callback(new Error("请上传封面图片"));
      } else {
        callback();
      }
    };
    return {
      tagSelectVisible: false,
      settingVisible: true,
      sameTitle: false, // 统一标题
      editDetailVisible: false, // 富文本编辑
      story: "", // 幕后故事内容
      modalVisible: false,
      priceSettingVisible: false,
      formatList: compressedList,
      tagsList: [[], []],
      rules: {
        title: [
          {
            required: true,
            message: "请输入素材名称",
            trigger: "blur",
          },
          {
            min: 4,
            max: 50,
            message: "长度在 4 到 50 个字符",
            trigger: "change",
          },
        ],
        info: [{ validator: info, trigger: "change", required: true }],
        allowDownload: [{ required: true }],
        tags: [{ validator: tags, required: true }],
        cover: [{ validator: coverRule, required: true }],
        acceptDonations: [{ required: true }],
      },
      applyLoading: false,
      access: false,
      form: {
        acceptDonations: false,
        id: -1,
        allowDownload: false,
        title: "",
        cover: "",
        tags: "",
        story: "",
        portraitureRightId: "",
        realRightId: "",
        firstPrice: "",
        haveSetDisPrice: false,
        haveSetMemDisPrice: false,
        haveSetTime: false,
        time: [],
        format: "",
        audioCodec: "COPY_OPTIMUM",
        colorEnhancement: "",
        colorPrimaries: "",
        colorRange: "",
        colorSpace: "",
        colorTransfer: "",
        crf: "23.0",
        fps: 0,
        inputGamma: "",
        inputGamut: "",
        outputGamma: "",
        outputGamut: "",
        peak: 100,
        pixelFormat: "YUV420P",
        sampleFormat: "S16",
        sts: true,
        size: 0,
        subtitleCodec: "COPY",
        toDynamicRange: "SDR",
        uploadConfiguration: true,
        videoCodec: "AVC",
        firstPrice: "", // 原价
        discountPrice: "", // 折扣价
        disProPrice: "", // 专业会员价格
        disAdvPrice: "", // 高级会员
        disBnsPrice: "", // 商业会员
      },
    };
  },
  watch: {
    form(form) {
      this.modalVisible = this.$refs.upload.fileList.length > 0;
    },
  },
  created() {
    this.form.allowDownload = Boolean(
      parseInt(this.$route.query.allowDownload)
    );
    if (this.form.allowDownload) {
      let content = "";
      checkVerified()
        .then(({ msg }) => {
          this.msg = msg;
          if (msg === "not.verified") {
            content = "出售付费素材需要实名认证, 是否前往认证？";
          } else if (msg === "waitting") {
            this.$message.warning("认证审核中, 请耐心等待");
          } else if (msg === "notPass") {
            content = "认证未通过, 是否重新认证？";
          }
          if (content) {
            this.$confirm(content)
              .then((_) => {
                this.$router.push("/gaia-material/check-verified");
              })
              .catch((_) => {
                this.form.allowDownload = false;
              });
          }
        })
        .catch((res) => {
          this.loading = false;
          this.$message.error("请检查网络");
        });
    }
    getMaterialTags(5).then((res) => {
      console.log(res);
      this.tagsList[0] = res.materialKeywordList.map((el) => {
        return el.content;
      });
    });
    getOwnMaterialTags(5).then((res) => {
      this.tagsList[1] = res.materialKeywordList.map((el) => {
        return el.content;
      });
    });
  },
  methods: {
    /**
     * 统一标题
     */
    changeTitle() {
      const fileList = this.$refs.upload.fileList;
      const checked = this.$refs.upload.checked;
      const name = this.form.title;
      if (this.sameTitle) {
        fileList.map((el, i) => {
          if (i !== checked) {
            i = i + 1;
            el.form.title = `${name} (${i + (i > checked ? 0 : 1)})`;
          }
        });
      } else {
        fileList.map((el, i) => {
          el.form.title = el.name;
        });
      }
    },
    /**
     * 文件列表被清空
     */
    clearForm() {
      this.modalVisible = false;
      this.editDetailVisible = false;
    },
    /**
     * 封面改变
     */
    coverChange(cover) {
      this.form.cover = cover;
    },
    /**
     * 打开富文本编辑器 以及保存到form表单
     */
    openEditDetail() {
      this.settingVisible = false;
      this.editDetailVisible = true;
      this.story = this.form.story;
    },
    editDetailSave(bool) {
      if (bool) {
        this.form.story = this.story;
      }
      this.story = "";
      this.settingVisible = true;
      this.editDetailVisible = false;
    },
    /**
     * price设置
     */
    showPriceSetting() {
      this.priceSettingVisible = true;
      this.settingVisible = false;
    },
    /**
     * 价格变化时 约束输入
     */
    priceMoreThan() {
      const form = this.form;
      form.firstPrice = Math.abs(form.firstPrice).toFixed(2);
      if (form.haveSetDisPrice) {
        form.discountPrice = Math.abs(form.discountPrice).toFixed(2);
      }
      if (form.haveSetMemDisPrice) {
        form.disProPrice = Math.abs(form.disProPrice).toFixed(2);
        form.disAdvPrice = Math.abs(form.disAdvPrice).toFixed(2);
        form.disBnsPrice = Math.abs(form.disBnsPrice).toFixed(2);
      }
    },
    /**
     * 保存价格 校验规则
     */
    priceSettingConfirm(form = null) {
      const f = this.form;
      if (f.haveSetDisPrice) {
        if (!f.haveSetTime && Number(f.discountPrice) == 0) {
          this.$message.error("折扣价为0时, 必须设置折扣时间");
          return;
        }
        if (!(Number(f.firstPrice) > Number(f.discountPrice))) {
          this.$message.error(
            "原价与折扣价设置错误, 相同转码分辨率 原价＞折扣价"
          );
          return;
        }
      }
      if (f.haveSetMemDisPrice) {
        if (
          !f.haveSetTime &&
          (Number(f.disProPrice) == 0 ||
            Number(f.disAdvPrice) == 0 ||
            Number(f.disBnsPrice) == 0)
        ) {
          this.$message.error("会员折扣价为0时, 必须设置折扣时间");
          return;
        }
        if (!(Number(f.firstPrice) > Number(f.disProPrice))) {
          this.$message.error("价格设置错误 原价＞会员折扣价");
          return;
        }
        if (!(Number(f.disProPrice) > Number(f.disAdvPrice))) {
          this.$message.error("价格设置错误 PRO会员折扣价≥ADV会员折扣价");
          return;
        }
        if (!(Number(f.disAdvPrice) > Number(f.disBnsPrice))) {
          this.$message.error("价格设置错误 ADV会员折扣价≥BNS会员折扣价");
          return;
        }
      }
      if (
        f.haveSetDisPrice &&
        f.haveSetMemDisPrice &&
        !(Number(f.discountPrice) > Number(f.disProPrice))
      ) {
        this.$message.error("价格设置错误 折扣价＞PRO会员折扣价");
        return;
      }
      if (f.haveSetTime) {
        if (!(Array.isArray(f.time) && f.time.length == 2)) {
          this.$message.error("未设置折扣时间");
          return;
        }
      }
      this.priceSettingVisible = false;
      this.settingVisible = true;
    },
    /**
     * 应用当前素材
     */
    upload() {
      return new Promise((resolve, reject) => {
        this.$refs["form"].validate((valid) => {
          if (valid) {
            const checked = this.$refs.upload.checked;
            if (this.$refs.upload.fileList[checked].status !== "ready") {
              this.$message.error("请勿重复点击");
              resolve();
              return;
            } else {
              let temp = JSON.parse(JSON.stringify(this.form));
              if (temp.allowDownload && temp.firstPrice == "") {
                this.$message.error("请设置价格");
                return;
              }
              console.log("submit!");
              temp.firstPrice = parseInt(temp.firstPrice * 100);
              temp.discountPrice = parseInt(temp.discountPrice * 100);
              temp.disProPrice = parseInt(temp.disProPrice * 100);
              temp.disAdvPrice = parseInt(temp.disAdvPrice * 100);
              temp.disBnsPrice = parseInt(temp.disBnsPrice * 100);
              if (Array.isArray(temp.time) && temp.time.length == 2) {
                temp.time = [
                  new Date(temp.time[0]).valueOf(),
                  new Date(temp.time[1]).valueOf(),
                ];
              }
              temp.keyword = temp.tags;
              this.$refs.upload.upload(checked, otherMaterial, temp);
              resolve();
              return;
            }
          } else {
            reject();
            console.log("error submit!!");
            return false;
          }
        });
      });
    },
    /**
     * 应用到全部
     */
    async submit() {
      const fileList = this.$refs.upload.fileList;
      for (let i = 0; i < fileList.length; i++) {
        this.$refs.upload.checked = i;
        await this.sleep(1000);
        await this.upload();
      }
      // console.log(this.$refs.upload.fileList);
      // this.$refs.upload.fileList.map(async (el, i) => {
      // });
    },
    sleep(time) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve();
        }, time);
      });
    },
  },
};
</script>
<style lang="less" >
.video-price-setting {
  .el-input--suffix .el-input__inner {
    padding-right: 20px;
    padding-left: 4px;
  }
}
</style>
<style lang="less" scoped>
.input-group {
  div {
    margin: 0 0 6px 3.5%;
  }
  div:nth-child(4n + 1) {
    margin-left: 0;
  }
}
.type-btn {
  height: 40px;
  line-height: 40px;
  margin: 30px 0;
  border-radius: 4px;
  font-size: 12px;
  color: #ffffff;
  background: linear-gradient(90deg, #6464fa 0%, #4ca0ff 100%);
  text-align: center;
  user-select: none;
  cursor: pointer;
  .bold {
    font-weight: bold;
    margin-right: 10px;
  }
}
.video-price-setting {
  .price-item {
    margin: 10px 0 20px;
    font-size: 14px;
    .tag {
      font-size: 12px;
    }
    .el-input {
      width: 16%;
      margin-right: 2.5%;
    }
    .el-input:last-child {
      margin-right: 0;
    }
  }
}
</style>
